/**
 * Use a class component to get access to lifecycle methods, otherwise use a functional component.
 * Should only contain rendering logic; business logic should be contained to Redux Sagas.
 */

import React from 'react';

class TestWidget extends React.Component {
    componentDidMount() {
        this.props.addMatch(this.props.data.pid);
    }

    render() {
        return (
            <h1>
                {this.props.matchItem
                    ? this.props.matchItem.match.name
                    : 'Loading'}
            </h1>
        );
    }
}

export default TestWidget;
